export default "__VITE_ASSET__DJh0Z$Sl__"